import React from "react";

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  label?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onCheckedChange,
  disabled = false,
  ...rest
}) => {
  return (
    <label
      className={`inline-flex items-center cursor-pointer select-none ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onCheckedChange(e.target.checked)}
        disabled={disabled}
        className="sr-only"
        {...rest}
      />
      <span
        className={`w-5 h-5 mr-2 flex justify-center items-center rounded border-2 border-primary 
                    ${checked ? "bg-primary border-primary" : "bg-cardBackground border-borderColor"} 
                    transition-colors duration-200`}
        aria-hidden="true"
      >
        {checked && (
          <svg
            className="w-3 h-3 text-cardBackground"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={3}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        )}
      </span>
      {label && <span className="text-bodyText">{label}</span>}
    </label>
  );
};

export default Checkbox;
